import { Documentos } from './documentos';
import { Deficiencia } from './deficiencia';
import { Telefone } from './telefone';
import { Endereco } from './endereco';
import { Instituicao } from './instituicao';

export class FichaCadastro {
  cpf: string = '';
  nome: string = '';
  dtNascimento: string = '';
  sexo: string = '';
  escrita: string = '';
  rg: string = '';
  rgOrgao: string = '';
  rgUf: string = '';
  rgDataExp: string = '';
  numOAB: string = '';
  orgaoExpOAB: string = '';
  email: string = '';
  pai: string = '';
  mae: string = '';
  autorizaSMS: boolean = false;
  nacionalidade: string = '';
  naturalidade: string = '';
  autorizaInfoPos: boolean = false;
  codTurno: string = '';
  codTurnoFake: string = '';
  cienciaConcurso: string = '';
  cotista: boolean = false;
  codTpCotista: string = '';
  instituicao!: Instituicao;
  endereco!: Endereco;
  telefone!: Telefone;
  deficiencia!: Deficiencia;
  indIsentoIR: string = '';
  indDesempregado: string = '';
  documentos!: Documentos[];
  ind_prazoConcurso : string = '';
  ind_alterouTipoCotista : boolean = false;

  constructor() {
    this.documentos! = new Array<Documentos>();
  }
}
